<div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth auth-bg-1 theme-one">
        <div class="row w-100 mx-auto">
          
          <div class="col-lg-4 mx-auto">
            
            <div class="auto-form-wrapper">

              <div class="logo-holder">
                <img src="/assets/images/logo.png">
              </div>
              
              <form #loginForm="ngForm">
                <div class="form-group">
                  <label class="label">Username</label>
                  <div class="input-group">
                    <input type="text" name="email" class="form-control" placeholder="Username" ngModel required>
                    <div class="input-group-append">
                      <span class="input-group-text"><i class="icon-check"></i></span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="label">Password</label>
                  <div class="input-group">
                    <input type="password" name="password" class="form-control" placeholder="*********" ngModel required>
                    <div class="input-group-append">
                      <span class="input-group-text"><i class="icon-check"></i></span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <button class="btn btn-primary submit-btn btn-block" (click)="tryLogin(loginForm.value)">Login</button>
                </div>
              </form>
            </div>
            <ul class="auth-footer">
              <li><a href="#">How to Use</a></li>
              <li><a href="#">Knowledgebase</a></li>
              <li><a href="#">Terms of Use</a></li>
            </ul>
            <p class="footer-text text-center">copyright © 2020 Phantompro. All rights reserved. </p>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>